import { type DropEvent, isFileDropItem } from "./DropZone";

export interface SingleFileDropHandlers {
  /** Handler for `DropZone`'s `onDrop` — resolves the first dropped file item. */
  onDrop: (e: DropEvent) => Promise<void>;
  /** Handler for `FileTrigger`'s `onSelect` — takes the first picked file. */
  onSelect: (files: FileList | null) => void;
}

/**
 * The single-file wiring shared by every styled upload surface
 * (`StandardDropZone`, `FileDropField`): drop resolves the first file item,
 * browse takes the first picked file, and both funnel into one callback.
 */
export function useSingleFileDrop(onFileSelect: (file: File) => void): SingleFileDropHandlers {
  return {
    onDrop: async (e) => {
      const fileItem = e.items.find(isFileDropItem);
      if (fileItem) onFileSelect(await fileItem.getFile());
    },
    onSelect: (files) => {
      const file = files?.[0];
      if (file) onFileSelect(file);
    },
  };
}
